export { default } from './PracticeDetails';
